<template>
  <inspector-frame v-if="!!key" @close="close" :x="-315" :y="-160">
    <div class="CharacterDetail">
      <header class="head">
        <div class="image" @click="selectImage" :style="{ backgroundImage: url }"></div>
        <div class="controles">
          <!-- <a class="btn" @click.prevent="selectImage">立ち絵設定</a> -->
          <a class="btn" @click.prevent="selectImage">画像設定</a>
          <a class="btn" @click.prevent="addTo(key)">盤面に追加</a>
          <a @click.prevent="removeFrom(key)" class="btn">盤面から削除</a>
          <a @click.prevent="remove(key)" class="btn">キャラデータ削除</a>
        </div>
      </header>
      <scrollview class="body">
        <form class="edit" @change="onChange">
          <input type="hidden" v-model="formData.imageKey">
          <div class="item">
            <p class="name">Name</p>
            <div class="input">
              <input type="text" v-model="name" @mousedown.stop>
            </div>
          </div>
          <div class="item">
            <p class="name">Status</p>
            <div class="inputGroup">
              <div class="input">
                <p class="label">INITIATIVE(DEX)</p>
                <input type="number" @change="(e) => changeParam('dex', e.currentTarget.value)" :value="params['dex']" @mousedown.stop>
              </div>
              <div class="input" v-for="(param, i) in characterParamList" :key="i">
                <p class="label">{{param.name || 'null'}}</p>
                <input type="number" @change="(e) => changeParam(param.key, e.currentTarget.value)" :value="params[param.key]" @mousedown.stop>
              </div>
              <!-- <div class="input">
                <p class="label">最大HP</p>
                <input type="number" v-model="hp" @mousedown.stop>
              </div>
              <div class="input">
                <p class="label">最大MP</p>
                <input type="number" v-model="mp" @mousedown.stop>
              </div>
              <div class="input">
                <p class="label">最大SAN</p>
                <input type="number" v-model="san" @mousedown.stop>
              </div>
              <div class="input">
                <p class="label">DEX</p>
                <input type="number" v-model="dex" @mousedown.stop>
              </div> -->
            </div>
          </div>
          <div class="item">
            <div class="input">
              <label class="label">秘匿キャラクター <input type="checkbox" v-model="hidden"></label>
            </div>
            <div class="input">
              <label class="label">駒サイズ <select v-model.number="size">
                <option value="0.25">0.25x</option>
                <option value="0.5">0.5x</option>
                <option value="1">1x - default</option>
                <option value="2">2x</option>
                <option value="3">3x</option>
                <option value="4">4x</option>
                <option value="5">5x</option>
                <option value="6">6x</option>
                <option value="7">7x</option>
                <option value="8">8x</option>
                <option value="9">9x</option>
                <option value="10">10x</option>
              </select></label>
            </div>
          </div>
        </form>
      </scrollview>
      <scrollview class="aside">
        <form class="edit" @change="onChange">
          <div class="item">
            <p class="name">Chat palet</p>
            <div class="input">
              <textarea v-model="memo" @mousedown.stop></textarea>
            </div>
          </div>
          <div class="item">
            <p class="name">Note</p>
            <textarea v-model="note" @mousedown.stop></textarea>
          </div>
        </form>
      </scrollview>
    </div>
  </inspector-frame>
</template>
<script>
import inspectorFrame from '../frames/inspector'
export default {
  components: { 'inspector-frame': inspectorFrame },
  computed: {
    key() {
      return this.$store.getters['characters/$currentKey']
    },
    formData() {
      return this.$store.getters['characters/$currentData']
    },
    origin() {
      return this.$store.getters['characters/$get'](this.key)
    },
    name: {
      get() {
        return this.formData.name
      },
      set(value) {
        this.$store.commit('characters/$change', { key: 'name', value })
      }
    },
    memo: {
      get() {
        return this.formData.memo
      },
      set(value) {
        this.$store.commit('characters/$change', { key: 'memo', value })
      }
    },
    note: {
      get() {
        return this.formData.note
      },
      set(value) {
        this.$store.commit('characters/$change', { key: 'note', value })
      }
    },
    hidden: {
      get() {
        return this.formData.hidden
      },
      set(value) {
        this.$store.commit('characters/$change', { key: 'hidden', value })
      }
    },
    size: {
      get() {
        return this.formData.size
      },
      set(value) {
        this.$store.commit('characters/$change', { key: 'size', value })
      }
    },
    params() {
      return this.formData.params
    },
    // hp: {
    //   get() {
    //     return this.formData.params.hp.value
    //   },
    //   set(value) {
    //     this.$store.commit('characters/changeParam', { key: 'hp', value })
    //   }
    // },
    // mp: {
    //   get() {
    //     return this.formData.params.mp.value
    //   },
    //   set(value) {
    //     this.$store.commit('characters/changeParam', { key: 'mp', value })
    //   }
    // },
    // san: {
    //   get() {
    //     return this.formData.params.san.value
    //   },
    //   set(value) {
    //     this.$store.commit('characters/changeParam', { key: 'san', value })
    //   }
    // },
    // dex: {
    //   get() {
    //     return this.formData.params.dex.value
    //   },
    //   set(value) {
    //     this.$store.commit('characters/changeParam', { key: 'dex', value })
    //   }
    // },
    url() {
      return this.$store.getters['images/getBackgroundUrl'](this.$store.getters['characters/$get'](this.key).imageKey)
    },
    characterParamList() {
      return this.$store.getters['room/characterParamList']
    }
  },
  methods: {
    onChange(e) {
      this.$store.dispatch('characters/$save')
    },
    changeParam(key, value) {
      this.$store.commit('characters/changeParam', { key, value })
    },
    remove(key) {
      this.$store.dispatch('characters/$remove', key)
    },
    close() {
      this.$store.commit('characters/$checkout', null)
    },
    selectImage() {
      this.$store.commit('selectors/open', {
        tags: ['characters'],
        action: 'characters/saveImage',
        context: { key: this.key }
      })
    },
    addTo(key) {
      // this.$store.commit('local/set', { key: 'currentCharacterKey', value: key })
      this.$store.dispatch('local/currentCharacterKey', key)
      this.$store.dispatch('characterList/$insert', {
        key: this.key,
        data: {
          characterKey: this.key,
          params: this.origin.params
        }
      })
    },
    removeFrom(key) {
      // this.$store.commit('local/set', { key: 'currentCharacterKey', value: key })
      this.$store.dispatch('local/currentCharacterKey', null)
      this.$store.dispatch('characterList/$remove', key)
    }
  }
}
</script>
<style scoped>
.CharacterDetail {
  width: 600px;
  height: 320px;
  display: flex;
  /*flex-flow: column;*/
}
.head {
  position: relative;
  border-right: 1px solid #222;
  width: 180px;
  background: rgba(0, 0, 0, 0.2);
}
.head .image {
  height: 100%;
  background-position: 50% 50%;
  background-size: cover;
  cursor: pointer;
}
.head .controles {
  padding: 5px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.head .controles a + a {
  margin-top: 2px;
}
.body {
  padding: 10px;
  flex: 1;
  /* overflow: scroll; */
}
.body .name {
  font-weight: 800;
}
.body textarea {
  height: 200px;
}
.btn {
  display: block;
  padding: 7px;
  background: rgba(0, 0, 0, 0.4);
}
.btn + .btn {
  margin-top: 5px;
}
.aside {
  padding: 10px;
  border-left: 1px solid #222;
  width: 180px;
  overflow: scroll;
}
.aside textarea {
  height: 200px;
}
</style>
